<template>
  <div class="page-root">
    <div class="d-flex align-center justify-space-between">
      <h1><span class="font-weight-bold">당근베팅</span></h1>
      <v-chip color="#fff3e0" text-color="#e8743b" class="font-weight-bold">🥕 {{ currencyBalance.toLocaleString() }}</v-chip>
    </div>
    <p class="text-caption grey--text mb-2">🥕를 모아 펫을 키워요</p>

    <v-tabs v-model="tab" class="mb-4" color="#c98a2e" slider-color="#c98a2e">
      <v-tab>🎲 확률게임</v-tab>
      <v-tab>🕹️ 아케이드</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- 베팅 탭 -->
      <v-tab-item>
        <div class="gather-grid">
          <v-card v-for="item in bets" :key="item.name" class="gather-card" outlined :hover="!!item.to">
            <div class="gather-card__emoji">{{ item.emoji }}</div>
            <div class="gather-card__name">{{ item.name }}</div>
            <div class="gather-card__desc">{{ item.desc }}</div>
            <v-btn
              v-if="item.to"
              class="gather-card__btn"
              rounded
              depressed
              dark
              color="#c98a2e"
              @click="$router.push(item.to)"
            >
              플레이
            </v-btn>
            <v-btn v-else class="gather-card__btn" rounded depressed disabled>준비중</v-btn>
          </v-card>
        </div>
      </v-tab-item>

      <!-- 아케이드 탭 -->
      <v-tab-item>
        <div class="gather-grid">
          <v-card v-for="item in arcades" :key="item.name" class="gather-card" outlined>
            <div class="gather-card__emoji">{{ item.emoji }}</div>
            <div class="gather-card__name">{{ item.name }}</div>
            <div class="gather-card__desc">{{ item.desc }}</div>
            <v-btn class="gather-card__btn" rounded depressed disabled>준비중</v-btn>
          </v-card>
        </div>
      </v-tab-item>

    </v-tabs-items>

    <p class="text-caption grey--text mt-6">※ 채집 미니게임은 준비 중입니다.</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "GatherPage",
  data() {
    return {
      tab: 0,
      // 탭 인덱스 ↔ 쿼리스트링 키 (?tab=). 순서 = v-tab 순서와 일치해야 함.
      //  출석/구매/버츄패스는 당근 다이얼로그(CurrencyDialog)로 이전 — 여기선 채집 게임만.
      tabKeys: ["bet", "arcade"],
      // 베팅: 🥕를 걸고 운에 맡기는 게임 (to 있으면 페이지 이동, 없으면 준비중)
      bets: [
        { emoji: "🎰", name: "슬롯머신", desc: "🥕를 걸고 잭팟에 도전", to: "/currency/gather/slot" },
        { emoji: "🪙", name: "동전 던지기", desc: "앞/뒤 맞히면 2배" },
        { emoji: "🎯", name: "다트 베팅", desc: "명중 구역에 따라 배당" },
        { emoji: "🃏", name: "하이로우", desc: "다음 카드 높을지 낮을지" },
      ],
      // 아케이드: 실력으로 🥕를 모으는 미니게임 (플레이스홀더)
      arcades: [
        { emoji: "🥕", name: "당근 캐기", desc: "타이밍 맞춰 당근을 쑥쑥" },
        { emoji: "🐰", name: "토끼 점프", desc: "장애물을 피해 멀리 가기" },
        { emoji: "🧺", name: "바구니 받기", desc: "떨어지는 🥕 받아내기" },
        { emoji: "🧩", name: "퍼즐", desc: "맞히고 🥕 보상 받기" },
      ],
    };
  },
  computed: {
    ...mapState(["currencyBalance"]),
  },
  watch: {
    // 탭 전환 시 URL ?tab= 동기화 (공유/뒤로가기용). 같은 값이면 스킵(중복 내비 방지).
    tab(idx) {
      const key = this.tabKeys[idx];
      if (!key || this.$route.query.tab === key) return;
      this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {});
    },
  },
  created() {
    // ?tab=<attendance|bet|arcade|buy|pass> 로 진입하면 해당 탭 활성화 (구 ?tab=buy 호환)
    const idx = this.tabKeys.indexOf(this.$route.query.tab);
    if (idx !== -1) this.tab = idx;
    this.$store.dispatch("loadCurrencyBalance");
  },
};
</script>

<style scoped>
.page-root {
  padding: 24px 28px;
}
.gather-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  padding-top: 4px;
}
.gather-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 16px 18px;
  border-radius: 14px;
}
.gather-card__emoji {
  font-size: 44px;
}
.gather-card__name {
  font-size: 15px;
  font-weight: 700;
  color: #2a2540;
}
.gather-card__desc {
  font-size: 12px;
  color: #8a8699;
  text-align: center;
  min-height: 32px;
}
.gather-card__btn {
  margin-top: 6px;
  width: 100%;
  font-weight: 700 !important;
}

/* 구매하기 탭 */
.balance-card {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  padding: 18px 28px;
  border-radius: 16px;
  background: linear-gradient(135deg, #fff4e0, #ffe6c2);
  border-color: #f1c98a !important;
}
.balance-card__label {
  font-size: 13px;
  color: #9a6a18;
}
.balance-card__value {
  font-size: 30px;
  font-weight: 800;
  color: #8a5d13;
}
.pkg-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 16px 18px;
  border-radius: 16px;
}
.pkg-card__emoji {
  font-size: 40px;
}
.pkg-card__amount {
  font-size: 22px;
  font-weight: 800;
  color: #6a4a14;
}
.pkg-card__bonus {
  font-size: 12px;
  font-weight: 700;
  color: #e0892b;
}
.pkg-card__buy {
  margin-top: 10px;
  width: 100%;
  font-weight: 700 !important;
}

/* 버츄패스 */
.pass-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  border-radius: 16px;
  margin-bottom: 18px;
  background: linear-gradient(135deg, #efe7ff, #e3d4ff);
  border: 1px solid #c9b3f5;
}
.pass-banner__emoji {
  font-size: 40px;
}
.pass-banner__title {
  font-size: 18px;
  font-weight: 800;
  color: #5a3aa0;
}
.pass-banner__desc {
  font-size: 13px;
  color: #7a6aa8;
}
.pass-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}
.pass-card {
  padding: 14px;
  border-radius: 12px;
}
.pass-card__level {
  font-size: 13px;
  font-weight: 800;
  color: #5a3aa0;
  margin-bottom: 8px;
}
.pass-card__row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 4px 0;
}
.pass-card__row.premium {
  color: #8e6fd6;
  font-weight: 700;
  border-top: 1px dashed #e1d8f3;
  margin-top: 4px;
}
.pass-card__track {
  color: #a8a4b8;
}
.pass-status {
  padding: 20px 22px;
  border-radius: 16px;
  text-align: center;
}
.pass-status--on {
  background: linear-gradient(135deg, #efe7ff, #e3d4ff);
  border-color: #c9b3f5 !important;
}
.pass-status__badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  background: #8e6fd6;
  border-radius: 999px;
  padding: 2px 10px;
  margin-bottom: 8px;
}
.pass-status__text {
  font-size: 14px;
  font-weight: 600;
  color: #5a3aa0;
}
</style>
